import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import firebase, { auth, db } from '../firebase';
import './Auth.css';
import { FaGoogle } from 'react-icons/fa6';

const Signup = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Cria usuário no Firestore após autenticar
  const createUserDoc = async (user) => {
    await db.collection('users').doc(user.uid).set({
      uid: user.uid,
      name,
      email: user.email,
      createdAt: firebase.firestore.FieldValue.serverTimestamp()
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validações
    if (!name || !email || !password || !confirmPassword) {
      setError('Por favor, preencha todos os campos.');
      return;
    }
    if (password !== confirmPassword) {
      setError('As senhas não coincidem.');
      return;
    }
    if (!termsAccepted) {
      setError('Você precisa aceitar os termos de serviço.');
      return;
    }

    try {
      // 1) Cria usuário no Firebase Auth
      const { user } = await auth.createUserWithEmailAndPassword(email, password);

      // 2) Atualiza displayName
      await user.updateProfile({ displayName: name });

      // 3) Grava doc no Firestore
      await createUserDoc(user);

      // 4) Redireciona
      navigate('/dashboard', { replace: true });
    } catch (err) {
      if (err.code === "auth/email-already-in-use") {
        setError("Este email já está cadastrado. Faça login ou recupere sua senha.");
      } else {
        setError(err.message);
      }
    }
  };

  const handleGoogleSignup = async () => {
    setError('');
    const provider = new firebase.auth.GoogleAuthProvider();
    // Após criar com Google:



    try {
      // 1) Login com Google
      const { user } = await auth.signInWithPopup(provider);
      // 2) Se for novo, cria doc no Firestore
      const doc = await db.collection('users').doc(user.uid).get();
      if (!doc.exists) {
        await db.collection('users').doc(user.uid).set({
          uid: user.uid,
          name: user.displayName,
          email: user.email,
          photoURL: user.photoURL,
          createdAt: firebase.firestore.FieldValue.serverTimestamp()
        });
      }
      // 3) Redireciona
      navigate('/dashboard', { replace: true });
    } catch (err) {
      if (err.code === "auth/account-exists-with-different-credential") {
        setError("Já existe uma conta com este email usando outro método. Faça login com seu provedor anterior.");
      } else {
        setError(err.message);
      }
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        {/* ...cabeçalho e logo... */}
        <div className="auth-header">
          <div className="logo">
            <div className="logo-icon">
              <i className="fas fa-brain"></i>
            </div>
            <h1>Academia <span>Gama</span></h1>
          </div>
          <h2>Crie sua conta</h2>
          <p>Comece sua jornada de desenvolvimento pessoal e profissional</p>
        </div>
        {error && <div className="auth-error">{error}</div>}


        <button className="google-button" onClick={handleGoogleSignup}>
          {/* ícone Google */}
          <FaGoogle className="mr-2" />
          <span style={{ marginLeft: "20px" }}>Cadastre-se com Google</span>
        </button>

        <div className="auth-divider"><span>Ou preencha o formulário</span></div>

        <form onSubmit={handleSubmit} className='border-sm'>
          {/* campos name, email, senha, confirmPassword, terms */}
          <div className="form-group">
            <label htmlFor="name">Nome Completo</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Seu nome completo"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu.email@exemplo.com"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Senha</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Crie uma senha"
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirme a Senha</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirme sua senha"
            />
          </div>

          <div className="terms">
            <input
              type="checkbox"
              id="terms"
              checked={termsAccepted}
              onChange={() => setTermsAccepted(!termsAccepted)}
            />
            <label htmlFor="terms">
              Concordo com os <Link to="/terms">Termos de Serviço</Link> e <Link to="/privacy">Política de Privacidade</Link>
            </label>
          </div>
          <button type="submit" className="auth-button">Criar Conta</button>
        </form>



        <div className="auth-footer">
          Já tem uma conta? <Link to="/login">Entrar</Link>
        </div>
      </div>

      <div className="auth-visual">
        <div className="visual-content">
          <h3>Sua jornada de desenvolvimento começa aqui</h3>
          <p>Ao criar uma conta na Academia Gama, você terá acesso a:</p>
          <div className="features">
            <div className="feature">
              <i className="fas fa-user-graduate"></i>
              <span>Módulos de orientação vocacional</span>
            </div>
            <div className="feature">
              <i className="fas fa-briefcase"></i>
              <span>Oportunidades profissionais</span>
            </div>
            <div className="feature">
              <i className="fas fa-comment-dots"></i>
              <span>Treinamento de oratória</span>
            </div>
            <div className="feature">
              <i className="fas fa-brain"></i>
              <span>Desenvolvimento de inteligência emocional</span>
            </div>
            <div className="feature">
              <i className="fas fa-file-alt"></i>
              <span>Currículo dinâmico que evolui com você</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;